// web-v2/src/lib/format.js
//
// DATE FORMATTING LIVES IN ./date-display.js AND IS RE-EXPORTED HERE.
//
// These are not wrappers, they are the same function objects, so the guard
// can assert the collapse BY IDENTITY (assert.strictEqual(a.fn, b.fn)). Two
// functions with the same body pass any behavioural check and then drift;
// one function re-exported cannot. Prompt 185 collapsed three date
// formatters into one for exactly that reason.
//
// Do not reintroduce a local date formatter in this file. If a surface needs
// a shape the canon does not offer, add it to date-display.js.
export { formatDate, formatHumanDate, daysUntil } from './date-display.js';

// CENTS ONLY WHEN THERE ARE CENTS (David 2026-10-01). This rounded every
// figure to whole dollars, so 161.55 printed as $162 and read as wrong math.
// A whole-dollar amount still prints without ".00"; an amount with cents
// prints both digits. Rounding to the cent first keeps float noise
// (1077 * 0.15 = 161.54999...) from deciding which case it is.
export function formatCurrency(n) {
  if (n == null || isNaN(Number(n))) return '—';
  const cents = Math.round(Number(n) * 100);
  const digits = cents % 100 === 0 ? 0 : 2;
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  }).format(cents / 100);
}

export function formatTail(n) {
  if (!n) return '—';
  return String(n).toUpperCase();
}
